import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-top-20-this-week',
  templateUrl: './top-20-this-week.component.html',
  styleUrls: ['./top-20-this-week.component.scss', '../../../dashboard.scss'],
  standalone: false
})
export class Top20ThisWeekComponent {
  @Input() dashboardData: any;
  GST_VALUE: any;
  targetImg: string = "<img class='target-arrow' src='assets/images/target_img.png' style='height:16px;vertical-align:middle;'/>";
  dashboardTop10Today: any[] = [];
  todayTop10Sum: number = 0;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dashboardData']) {
      this.dashboardTop10Today = (this.dashboardData?.dashboard_top10_this_week || []).map((item: any) => ({
        ...item,
        amount: Number(item.amount) || 0
      }));
      this.todayTop10Sum = this.dashboardTop10Today.reduce((sum: any, item: any) => sum + (item.amount || 0), 0);
      // console.log(this.todayTop10Sum)
    }
  }
  getPercent(amount: number): number {
    return this.todayTop10Sum ? (amount / this.todayTop10Sum) * 100 : 0;
  }
}
